import s from "./Header.module.scss";
import classNames from "classnames";
import clsx from "clsx";
import logo from "./image/log.png";
import logName from "./image/logo1.png";
import searchIcon from "./image/searchIcon.svg";
import closeIcon from "./image/closeIcon.svg";
import burgerIcon from "./image/burgerIcon.png";
import addIcon from "./image/addIcon.svg";
import editorIcon from "./image/editorIcon.png";
import accountIcon from "./image/accountIcon.svg";
import { Container } from "layouts/Container/Container";
import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef, useCallback } from "react";
import telegram from "./image/TelegramIcon.svg";
import vk from "../Footer/images/vk.svg";
import odnockasnic from "../Footer/images/Odnaclas.svg";

import { API_BASE } from "config/api";
import { useIsLoggedIn } from "hooks/isLoggedIn";
import { useOnlineStatus } from "hooks/useOnlineStatus";

export const Header = () => {
  const navigate = useNavigate();

  const isOnline = useOnlineStatus();
  const isLoggedIn = useIsLoggedIn();

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [menuType, setMenuType] = useState<
    "fullScreen" | "sidebar" | "desktop"
  >("desktop");
  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  const handleResize = useCallback(() => {
    const width = window.innerWidth;
    const newMenuType =
      width <= 375 ? "fullScreen" : width <= 769 ? "sidebar" : "desktop";

    setMenuType((prev) => {
      if (prev !== newMenuType) {
        if (newMenuType === "desktop") closeMenu();
        return newMenuType;
      }
      return prev;
    });
  }, [closeMenu]);

  // состояния для обработки поисковой строки
  const [isSearchOpen, setSearchOpen] = useState(false);
  const searchRef = useRef<HTMLDivElement | null>(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResult, setSearchResult] = useState<Event[]>([]);
  const [isSearching, setIsSearching] = useState(false);

  const handleSearchOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isOnline) return;
    setSearchOpen((prev) => !prev);
  };

  interface Event {
    id: string;
    cover_medium: string;
    name: string;
    starts_at: string;
    categories: string[];
    place: {
      name: string;
      city: string;
      address: {
        street: string;
        house_number: string;
      };
    };
    price_min: number;
  }

  //  обработка данных  с бэк

  const fetchSearchResults = useCallback(
    async (query: string, signal?: AbortSignal) => {
      try {
        const response = await fetch(
          `${API_BASE}/events/?search=${encodeURIComponent(query)}`,
          { signal }
        );

        if (!response.ok) throw new Error("Ошибка при получении данных");

        const data = await response.json();
        const lowerQuery = query.toLowerCase();

        const results = data.results.filter((event: Event) =>
          event.name.toLowerCase().includes(lowerQuery)
        );

        // const results = data.results.filter((event: Event) =>
        //   event.name.toLowerCase().includes(searchQuery.toLowerCase())
        // );

        return results;
      } catch (error) {
        throw error;
      }
    },
    []
  );

  useEffect(() => {
    const trimmedQuery = searchQuery.trim();

    if (!isOnline) {
      setSearchQuery("");
      setSearchResult([]);
      setIsSearching(false);
      return;
    }

    if (trimmedQuery.length < 3) {
      setSearchResult([]);
      setIsSearching(false);
      return;
    }

    const controller = new AbortController();
    const delay = setTimeout(() => {
      setIsSearching(true);
      fetchSearchResults(trimmedQuery, controller.signal)
        .then((data) => {
          setSearchResult(data);
          setIsSearching(false);
        })
        .catch(() => {
          setSearchResult([]);
          setIsSearching(false);
        });
    }, 600);

    return () => {
      clearTimeout(delay);
      controller.abort();
    };
  }, [searchQuery, fetchSearchResults, isOnline]);

  useEffect(() => {
    handleResize(); // Для инициализации при загрузке
    const resizeHandler = () => window.requestAnimationFrame(handleResize);

    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
  }, [handleResize]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        menuOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target as Node)
      ) {
        setMenuOpen(false);
      }
    };
    const handleClickSearchOutside = (e: MouseEvent) => {
      if (
        isSearchOpen &&
        searchRef.current &&
        !searchRef.current.contains(e.target as Node) &&
        !(e.target as Element).closest(".searchBtn")
      ) {
        closeSearch();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("click", handleClickSearchOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("click", handleClickSearchOutside);
    };
  }, [menuOpen, isSearchOpen]);

  const closeSearch = () => {
    setSearchOpen(false);
    setSearchQuery(""); // Очищаю поле инпута
    setSearchResult([]); // Очищаю результаты поиска
    setIsSearching(false); // Сбрасываю статус поиска
  };

  return (
    <>
      {menuType === "desktop" ? (
        <Container>
          <header className={s.header}>
            {" "}
            <div className="header_left">
              <NavLink to="/" onClick={() => navigate(`homePage`)}>
                {/* <img className={s.logo} src={logo} alt="logoIcon" /> */}
                <img className={s.logoName} src={logName} alt="logoIcon" />
              </NavLink>{" "}
            </div>
            <div className={s.header_right}>
              <NavLink
                to="/createEventPage"
                className={s.header_newEvent}
                onClick={() => navigate(`createEventPage`)}
              >
                Создать новое событие
              </NavLink>
              <div className={s.header_wrapIcons}>
                <div className={s.search}>
                  <button
                    className={s.searchBtn}
                    type="button"
                    onClick={handleSearchOpen}
                    disabled={!isOnline}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M16.0041 15.4585L20.0631 19.5M11.0627 6.5C13.2718 6.5 15.0627 8.29086 15.0627 10.5M18.0627 10.5C18.0627 6.63401 14.9287 3.5 11.0627 3.5C7.19669 3.5 4.06268 6.63401 4.06268 10.5C4.06268 14.366 7.19669 17.5 11.0627 17.5C14.9287 17.5 18.0627 14.366 18.0627 10.5Z"
                        stroke="#675D75"
                        strokeWidth={1.5}
                        strokeLinecap="round"
                      />
                    </svg>
                    {/* <img src={searchIcon} alt="searchIcon" /> */}
                  </button>

                  {isSearchOpen && (
                    <div className={s.searchDropdown} ref={searchRef}>
                      <Container>
                        <div className={s.inputContainer}>
                          <div className={s.searchInput}>
                            <input
                              type="text"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                          </div>
                          <div className={s.iconsContainer}>
                            <button
                              type="button"
                              className={s.searchButton}
                              onClick={() => setSearchOpen(true)}
                            >
                              <img src={searchIcon} alt="searchIcon" />
                            </button>
                            <button
                              type="button"
                              className={s.clearButton}
                              onClick={closeSearch}
                            >
                              <img src={closeIcon} alt="Закрыть поиск" />
                            </button>
                          </div>
                        </div>
                      </Container>

                      {/* ................отрисовка результата поиска.................. */}

                      <div className={s.searchResults}>
                        <Container>
                          {isSearching ? (
                            <div className={s.searchStatus}>Поиск...</div>
                          ) : searchResult.length > 0 ? (
                            <>
                              <div className={s.resultWrapp}>
                                <div className={s.resultLeftWrapp}>
                                  <div className={s.resultsHeader}>
                                    <span className={s.allResults}>
                                      Все результаты
                                    </span>
                                    <button type="button">
                                      {searchResult.length}
                                    </button>
                                  </div>

                                  <div className={s.resultsHeader}>
                                    <div className={s.eventTitle}>
                                      {searchQuery}
                                    </div>
                                    <span className={s.eventLength}>
                                      {searchResult.length}{" "}
                                    </span>
                                  </div>
                                </div>
                                <div className={s.resultRightWrapp}>
                                  <div className={s.resultsItemHeader}>
                                    {searchQuery}
                                  </div>
                                  {searchResult.map((event) => (
                                    <div className={s.searchresultwrapp}>
                                      <NavLink
                                        key={event.id}
                                        to={`/event/${event.id}`}
                                        className={s.searchResultItem}
                                        onClick={() => setSearchOpen(false)}
                                      >
                                        <img
                                          className={s.searchResultImg}
                                          src={event.cover_medium}
                                          alt={event.name}
                                        />

                                        <div className={s.eventMainInfo}></div>
                                        <div className={s.eventMeta}>
                                          <div className={s.eventDate}>
                                            {event.name}
                                            <p>
                                              {new Date(
                                                event.starts_at
                                              ).toLocaleDateString("ru-RU", {
                                                day: "numeric",
                                                month: "long",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                              })}
                                            </p>
                                          </div>

                                          <div className={s.eventDate}></div>
                                          <div className={s.eventLocation}>
                                            {`
                                            
                                           ${event.place.city}
                                           `}
                                          </div>
                                          <div className={s.eventPrice}>
                                            {event.price_min > 0
                                              ? `${event.price_min.toLocaleString(
                                                  "ru-RU"
                                                )} ₽`
                                              : "Бесплатно"}
                                          </div>
                                        </div>
                                      </NavLink>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </>
                          ) : searchQuery ? (
                            <div className={s.noResults}>
                              <div className={s.noResultsText}>
                                Ничего не найдено
                              </div>
                            </div>
                          ) : null}
                        </Container>
                      </div>
                    </div>
                  )}
                </div>
                <div className={s.account}>
                  <button
                    className={s.accountBtn}
                    type="button"
                    onClick={() => {
                      navigate(
                        isLoggedIn ? "/accountPage" : "/registrationPage"
                      );
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M4.68808 21C4.68808 16.8579 8.04594 13.5 12.1881 13.5C16.3302 13.5 19.6881 16.8579 19.6881 21M15.6881 7C15.6881 8.933 14.1211 10.5 12.1881 10.5C10.2551 10.5 8.68808 8.933 8.68808 7C8.68808 5.067 10.2551 3.5 12.1881 3.5C14.1211 3.5 15.6881 5.067 15.6881 7Z"
                        stroke="#675D75"
                        strokeWidth={1.5}
                        strokeLinecap="round"
                      />
                    </svg>
                    {/* <img src={accountIcon} alt="accountIcon" /> */}
                  </button>
                </div>
              </div>
            </div>
          </header>
        </Container>
      ) : (
        <div className={s.container}>
          <header>
            <nav className={s.mobileMenu}>
              <button type="button" onClick={toggleMenu}>
                <img src={burgerIcon} alt="меню" />
              </button>{" "}
              <div className={s.mobileMenu_logo}>
                <NavLink to="/" onClick={() => navigate(`/`)}>
                  <p>А — КАССА</p>
                </NavLink>
              </div>
              <div className={s.search}>
                <button
                  type="button"
                  onClick={handleSearchOpen}
                  disabled={!isOnline}
                >
                  <img
                    className={s.searchBtn}
                    src={searchIcon}
                    alt="searchIcon"
                  />
                </button>
                {isSearchOpen && (
                  <div className={s.searchDropdown} ref={searchRef}>
                    <div className={s.inputContainer}>
                      <input
                        type="text"
                        className={s.searchInput}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      <div className={s.iconsContainer}>
                        <button
                          type="button"
                          className={s.searchButton}
                          onClick={() => {
                            setSearchOpen(true);
                            setSearchQuery("");
                          }}
                        >
                          <img src={searchIcon} alt="поиск" />
                        </button>

                        <button
                          type="button"
                          className={s.clearButton}
                          onClick={closeSearch}
                        >
                          <img src={closeIcon} alt="Закрыть поиск" />
                        </button>
                      </div>
                    </div>

                    {/* ................отрисовка результата поиска   МВ.................. */}

                    <div className={s.searchResults}>
                      {isSearching ? (
                        <div className={s.searchStatus}>Поиск...</div>
                      ) : searchResult.length > 0 ? (
                        <>
                          <div className={s.resultWrapp}>
                            <div className={s.resultLeftWrapp}>
                              <div className={s.resultsHeader}>
                                <span>Все результаты</span>
                                <button type="button">
                                  {searchResult.length}
                                </button>
                              </div>

                              <div
                                className={classNames(
                                  s.resultsHeader,
                                  s.resultsHeader_block
                                )}
                              >
                                <div className={s.eventTitle}>
                                  {searchQuery}
                                </div>
                                <span>{searchResult.length} </span>
                              </div>
                            </div>
                            <div className={s.resultRightWrapp}>
                              <div className={s.resultsItemHeader}>
                                {searchQuery}
                              </div>
                              {searchResult.map((event) => (
                                <div className={s.searchresultwrapp}>
                                  <NavLink
                                    key={event.id}
                                    to={`event/${event.id}`}
                                    className={s.searchResultItem}
                                    onClick={() => setSearchOpen(false)}
                                  >
                                    <img
                                      className={s.searchResultImg}
                                      src={event.cover_medium}
                                      alt={event.name}
                                    />
                                    <div className={s.eventMainInfo}></div>
                                    <div className={s.eventMeta}>
                                      <div className={s.eventDate}>
                                        {event.name}
                                      </div>
                                      <div className={s.eventDate}>
                                        {new Date(
                                          event.starts_at
                                        ).toLocaleDateString("ru-RU", {
                                          day: "numeric",
                                          month: "long",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })}
                                      </div>
                                      <div className={s.eventLocation}>
                                        {`${event.place.city},
                                           ${event.place.name}, 
                                           ${event.place.address.street}, 
                                           ${event.place.address.house_number}`}
                                      </div>
                                      <div className={s.eventPrice}>
                                        {event.price_min > 0
                                          ? `${event.price_min.toLocaleString(
                                              "ru-RU"
                                            )} ₽`
                                          : "Бесплатно"}
                                      </div>
                                    </div>
                                  </NavLink>
                                </div>
                              ))}
                            </div>
                          </div>
                        </>
                      ) : searchQuery ? (
                        <div className={s.noResults}>
                          <div className={s.noResultsText}>
                            Ничего не найдено
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                )}
              </div>
            </nav>
          </header>
        </div>
      )}

      <div className={s.container}>
        {menuType !== "desktop" && (
          <nav
            ref={menuRef}
            className={clsx(`${s.mobileMenuBar} 
      ${menuOpen ? s.open : ""} 
      ${menuType === "fullScreen" ? s.fullscreen : s.sidebar}`)}
          >
            <div className={s.mobileCloseButton}>
              <button
                className={s.closeButton}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleMenu();
                }}
              >
                <img src={closeIcon} alt="Закрыть меню" />
              </button>
            </div>
            <ul className={s.mobile_Menu_list}>
              <NavLink
                to="/accountPage"
                onClick={() => {
                  navigate(`accountPage`);
                  toggleMenu();
                }}
              >
                <li className={s.mobileNav_item}>
                  <img src={accountIcon} alt="Личный кабинет" />
                  <span>Личный кабинет</span>
                </li>
              </NavLink>

              {!isLoggedIn && (
                <NavLink
                  to="/registrationPage"
                  onClick={() => {
                    navigate(`registrationPage`);
                    toggleMenu();
                  }}
                >
                  <li className={s.mobileNav_item}>
                    <img src={editorIcon} alt="Регистрация" />
                    <span>Регистрация</span>
                  </li>
                </NavLink>
              )}

              <NavLink
                to="/createEventPage"
                onClick={() => {
                  navigate(`createEventPage`);
                  toggleMenu();
                }}
              >
                <li className={s.mobileNav_item}>
                  <img src={addIcon} alt="Создать событие" />
                  <span>Создать событие</span>
                </li>
              </NavLink>
            </ul>

            <ul className={s.mobile_Category_list}>
              <li
                className={s.mobile_Category_item}
                onClick={() => {
                  navigate("/", { state: { category: "Все" } });
                  closeMenu(); // Закрываем меню
                }}
              >
                Все
              </li>
              <li
                className={s.mobile_Category_item}
                onClick={() => {
                  navigate("/", { state: { category: "Музыка" } });
                  closeMenu(); // Закрываем меню
                }}
              >
                Музыка
              </li>
              <li
                className={s.mobile_Category_item}
                onClick={() => {
                  navigate("/", { state: { category: "Образование" } });
                  closeMenu();
                }}
              >
                Образование
              </li>
              <li
                className={s.mobile_Category_item}
                onClick={() => {
                  navigate("/", { state: { category: "Культура" } });
                  closeMenu(); // Закрываем меню
                }}
              >
                Культура
              </li>
              <li
                className={s.mobile_Category_item}
                onClick={() => {
                  navigate("/", { state: { category: "Здоровье" } });
                  closeMenu(); // Закрываем меню
                }}
              >
                Здоровье
              </li>
              <li
                className={s.mobile_Category_item}
                onClick={() => {
                  navigate("/", { state: { category: "Отдых" } });
                  closeMenu(); // Закрываем меню
                }}
              >
                Отдых
              </li>
              <li
                className={s.mobile_Category_item}
                onClick={() => {
                  navigate("/", { state: { category: "IT" } });
                  closeMenu(); // Закрываем меню
                }}
              >
                IT
              </li>
            </ul>

            {/* <ul className={s.mobile_Category_list}>
              <li className={s.mobile_Category_item}>Музыка </li>
              <li className={s.mobile_Category_item}> Образование</li>
              <li className={s.mobile_Category_item}>Культура</li>
              <li className={s.mobile_Category_item}>Отдых</li>
            </ul> */}

            <div className={s.mobile_Menu_footer}>
              {/* <ul className={s.mobile_Menu_footer_list}>
                <li className={s.mobile_Menu_footer_list_item}>
                  <img src="" alt="" />
                </li>
                <li className={s.mobile_Menu_footer_lists_item}>
                  {" "}
                  <img src="" alt="" />
                </li>
                <li className={s.mobile_Menu_footer_list_item}>
                  <img src="" alt="" />
                </li>
              </ul> */}
              <div className={s.mobile_Menu_footer_list}>
                <a
                  href="https://t.me"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={s.mobile_Menu_footer_list_item}
                    src={telegram}
                    alt="Telegram"
                  />
                </a>
                <a
                  href="https://vk.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={s.mobile_Menu_footer_list_item}
                    src={vk}
                    alt="Вконтакте"
                  />
                </a>
                <a
                  href="https://ok.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={s.mobile_Menu_footer_list_item}
                    src={odnockasnic}
                    alt="Одноклассники"
                  />
                </a>
              </div>
            </div>
          </nav>
        )}
      </div>
    </>
  );
};
